import { CalcRows2019Controller } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Shows a mobile friendly rows editor for addding calculation rows: Salaries, expenses, benefits etc.
 * @example
 * ```html
 * <salaxy-calc-rows-editor parent="$ctrl.current" title="Matkalaskun rivit" on-commit="$ctrl.recalculate()" show-edit-buttons="false" show-gross-totals="true"
            template-url=""
            categories="['expenses']"
            is-in-edit="!$ctrl.current.isReadOnly">
 * ```
 */
export class CalcRowsEditor extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = CalcRows2019Controller.bindings;

  /**
   * The "footer" is at the bottom of the rows list where "Add new row" buttons would typically be.
   */
  public transclude = {
    footer: "?footer",
  };

  /** Uses the CalcRows2019Controller */
  public controller = CalcRows2019Controller;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/2022/CalcRowsEditor.html";
}
